import { Link } from "react-router-dom";

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  status: string;
  tags: string[];
  updateDate: string;
}

export default function ComicCard({
  slug,
  title,
  author,
  cover,
  rating,
  views,
  status,
  tags,
  updateDate,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${slug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-[10px] bg-background-50/90 text-foreground-900 px-2 py-0.5 rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="absolute top-2 left-2">
          <span
            className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
              status === "连载中"
                ? "bg-accent-500 text-background-50"
                : "bg-foreground-700 text-background-50"
            }`}
          >
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
          <span className="w-3 h-3 flex items-center justify-center text-accent-500">
            <i className="ri-star-fill text-[10px]"></i>
          </span>
          <span className="text-[11px] font-semibold text-foreground-900">{rating}</span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[10px] text-foreground-400">
          <span className="w-3 h-3 inline-flex items-center justify-center mr-0.5">
            <i className="ri-eye-line text-[10px]"></i>
          </span>
          {formatViews(views)}
        </span>
        <span className="text-[10px] text-foreground-400">更新于 {updateDate}</span>
      </div>
    </Link>
  );
}